<template>
  <div id="main-content">
    <a-form layout="inline" style="background: #ffffff;padding: 10px;margin-bottom: 10px;border-radius: 10px;">
      <a-form-item>
        <a-radio-group button-style="solid" v-model="dimension" @change="init_data">
          <a-radio-button value="channel">
            渠道
          </a-radio-button>
          <a-radio-button value="advertiser_id">
            账户
          </a-radio-button>
        </a-radio-group>
      </a-form-item>
      <a-form-item>
        <a-radio-group button-style="solid" v-model="cate" @change="init_data">
           <a-radio-button value="">
             全部
           </a-radio-button>
           <a-radio-button value="game">
             游戏
           </a-radio-button>
           <a-radio-button value="ai">
             AI
           </a-radio-button>
         </a-radio-group>
      </a-form-item>
      <a-form-item>
        <a-select v-model="channel" style="width: 200px" allowClear
                  mode="multiple" :maxTagCount="1" optionFilterProp="label" placeholder="请选择展示渠道"
                  @change="init_data">
          <a-select-option v-for="(channelName,channelItem) in channelList"
                           :label="channelName"
                           :key="channelItem">
            {{channelName}}
          </a-select-option>
        </a-select>
      </a-form-item>
      <a-form-item v-if="dimension==='advertiser_id'">
        <a-input v-model="advertiser_id" placeholder="请输入检索账号" @pressEnter="init_data"></a-input>
      </a-form-item>
<!--      <a-form-item>-->
<!--        <a-select v-model="product" style="width: 200px" allowClear showSearch-->
<!--                  :maxTagCount="1" placeholder="请选择产品"-->
<!--                  optionFilterProp="label"-->
<!--                  @change="init_data()">-->
<!--          <a-select-option v-for="productItem in $store.getters.getAppAll"-->
<!--                           :label="productItem.app_name"-->
<!--                           :value="productItem.app_id"-->
<!--                           :key="productItem.app_id">-->
<!--            <img :src="productItem.icon" style="height: 28px;border-radius: 5px;">-->
<!--            {{productItem.app_name}}-->
<!--          </a-select-option>-->
<!--        </a-select>-->
<!--      </a-form-item>-->
      <a-form-item style="float: right;margin: 0">
        <a-button type="primary" @click="downLoad" >导出</a-button>
      </a-form-item>
      <a-form-item style="float: right">
        <a-range-picker v-model="date"
                        valueFormat="YYYY-MM-DD"
                        style="width: 240px;" @change="init_data()" />
      </a-form-item>
    </a-form>
    <a-table :columns="getTableColumns" id="show-table"
             style="flex: 1;overflow-y: hidden;background: #ffffff"
             :scroll="{ x: '500px',y: _get_table_scroll({id:'show-table'}) }" :data-source="tableData"
             :rowKey="item=>item.dimension" :loading="tableLoad"
             bordered :pagination="false">
      <!--<template slot="footer"  slot-scope="currentPageData">-->
      <!--  <a-pagination-->
      <!--    v-model="page"-->
      <!--    style="text-align: right"-->
      <!--    show-size-changer-->
      <!--    :total="count"-->
      <!--    :page-size="page_size"-->
      <!--    @change="changePage"-->
      <!--    @showSizeChange="changePage"-->
      <!--  />-->
      <!--</template>-->
    </a-table>
  </div>
</template>

<script>
import {GetSpendCheck} from "../../../api/v1/spend_api";

export default {
  name: "Index",
  data(){
    return {
      dimension:'channel',
      advertiser_id:'',
      product:undefined,
      channel:[],
      channelList:{},
      date:['',''],
      tableData:[],
      fields:[],
      cate:'',
      tableLoad:false
    }
  },
  mounted() {
    this.init_channel()
    this.init_data()
  },
  computed: {
    getTableColumns(){
      let _table_columns = [
        {title: '维度指标',width:300,
          dataIndex: 'dimension',fixed:'left',align:'center',
          sorter:(a, b) => a.base_dimension - b.base_dimension,
        },
      ]
      this.fields.forEach(item=>{
        _table_columns.push({
          title: item,
          dataIndex: item,
          width: 150,
          align:'center'
        })
      })
      _table_columns.push({title: '汇总',width:150,
        dataIndex: 'count',fixed:'right',align:'center',
        sorter:(a, b) => a.count - b.count,})
      return _table_columns
    }
  },
  methods:{
    init_channel(){
      this.channelList={
        'facebook':'Facebook',
        'google':'Google',
        'tiktok':'Tiktok',
        'apple':'Apple',
        'unity':'Unity',
        'applovin':'Applovin',
        'vungle':'Vungle',
        'ironSource':'IronSource',
        'mintegral':'MTG',
      }
    },
    init_data(){
      if (this.tableLoad) return
      this.tableLoad = true
      GetSpendCheck({
        app_id:this.product,
        dimension:this.dimension,
        advertiser_id:this.advertiser_id,
        start:this.date[0],
        end:this.date[1],
        cate:this.cate,
        channel:this.channel
      }).then(resp=>{
        this.tableLoad = false
        if (resp.code===200){
          this.date = resp.data.date
          this.tableData = resp.data.list
          this.fields = resp.data.fields
        }
      })
    },
    changeDate(){
      console.log(this.date)
    },
    changeChannel(){
      console.log(this.channel)
    },
    downLoad(){
      let name = "细分核对数据"
      name += this.date[0]+"至"+this.date[1]+"的"
      this._export_cvs(Object.values(this.tableData),this.getTableColumns,name)
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/Spend/Check/Index.vue